import React from 'react';
import { View } from 'react-native';
import Text from 'design-system/Text';
import { rem, Spacer } from 'design-system';
import { IconCoins } from 'design-system/icons';
import FlatListItemCard from 'design-system/FlatListItemCard';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { getRewardTextToShow } from 'features/rewards/hooks/useRewards';
import RewardLogo from './RewardLogo';
export const RewardListItem = React.memo(({ index, itemsLength, reward, onPress }) => {
    const { subtitle, title } = reward;
    const colors = useColors();
    const styles = useStyles(styleSet);
    const rewardToShow = getRewardTextToShow(reward, true);
    return (<FlatListItemCard key={reward.id} index={index} style={styles.card} itemsLength={itemsLength} onPress={() => onPress?.(reward)}>
        <View style={styles.container}>
          <RewardLogo data={reward}/>
          <View style={styles.textContainer}>
            <Text Text-16>{title}</Text>
            {subtitle ? (<Text TextThin-14 Gray>
                {subtitle}
              </Text>) : null}
          </View>
          {reward ? (<View style={styles.cashbackLabel}>
              <IconCoins color={colors.text.statusPositive}/>
              <Spacer w={4}/>
              <Text Positive Text-14>
                {rewardToShow}
              </Text>
            </View>) : null}
        </View>
      </FlatListItemCard>);
});
const styleSet = createStyleSheets((colors) => ({
    container: {
        flex: 1,
        alignItems: 'center',
        flexDirection: 'row',
        paddingVertical: rem(16),
        paddingHorizontal: rem(16),
    },
    textContainer: {
        flex: 1,
        paddingHorizontal: rem(16),
    },
    cashbackLabel: {
        borderRadius: rem(6),
        flexDirection: 'row',
        alignItems: 'center',
        marginVertical: rem(8),
        paddingVertical: rem(3),
        paddingHorizontal: rem(9),
        backgroundColor: colors.elements.positiveLight,
    },
    card: {
        backgroundColor: colors.cards.onDark,
    },
}));
